import React, { useEffect, useState } from "react";
import { Card, Form } from "react-bootstrap";
import Alvo, { IAlvo } from "../Alvo";
import axios from "axios";
import ProgramaDefinicaoCustom, { IResposta } from "./ProgramaDefinicaoCustom";

export interface ICategoria {
  id: number;
  nome: string;
}

export interface IPerguntaForm {
  titulo: string;
  categoriaId?: number;
  alvos: IAlvo[];
}
interface IProgramaProps {
  alvos: IAlvo[];
  setAlvos: Function;
  categoriaId: number | undefined,
  setCategoriaId: Function,
  respostas: IResposta[],
  setRespostas: Function,
  titulo: string,
  setTitulo: Function
}

export default function ProgramaDefinicaoCard({alvos, setAlvos, categoriaId, setCategoriaId, titulo, setTitulo, respostas, setRespostas} : IProgramaProps) {
  const [categorias, setCategorias] = useState<ICategoria[]>([]);

  useEffect(() => {
    carregarCategorias();
  }, []);

  async function carregarCategorias() {
    const cat = (await axios.get('/programacategoria')).data
    setCategorias(cat)
  }

  return (
    <Card>
      <Card.Header>
        <Card.Title>Definição de Programa</Card.Title>
      </Card.Header>

      <Card.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Título</Form.Label>

            <Form.Control
              type="text"
              placeholder="Digite o título"
              value={titulo}
              onChange={(e) => setTitulo(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-4">
            <Form.Label>Categoria</Form.Label>

            <Form.Select
              value={categoriaId ?? ""}
              onChange={(e) =>
                setCategoriaId(
                  e.target.value ? Number(e.target.value) : undefined,
                )
              }
            >
              <option value="">Selecione uma categoria</option>

              {categorias.map((categoria) => (
                <option key={categoria.id} value={categoria.id}>
                  {categoria.nome}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          <Alvo alvos={alvos} setAlvos={setAlvos} />
          <ProgramaDefinicaoCustom 
            respostas={respostas} 
            setRespostas={setRespostas}          
          />
        </Form>
      </Card.Body>
    </Card>
  );
}
